import {
  Box,
  Link,
  Container,
  Dialog,
  IconButton,
  styled,
  Typography,
  useMediaQuery,
  Button
} from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import PersonOutline from '@material-ui/icons/PersonOutline';
import clsx from 'clsx';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import React, { FC, useEffect, useState } from 'react';
import Image from '../components/DirectImage';
import { useAuthContext } from '../context/auth_context';
import { layoutConstant } from '../utils/constants';
import Login from '../pages/Login';

export const HeaderWrapper = styled(Box)(({ theme }) => ({
  position: 'relative',
  zIndex: 1,
  height: layoutConstant.headerHeight,
  background: theme.palette.background.paper,
  transition: 'height 250ms ease-in-out',

  [theme.breakpoints.down('sm')]: {
    height: layoutConstant.mobileHeaderHeight
  }
}));

export default function Header({ isFixed, className }) {
  const { isAuth, handleSignout, email } = useAuthContext();
  const [dialogOpen, setDialogOpen] = useState(false);
  const navigate = useNavigate();
  // const router = useRouter();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));
  const toggleDialog = () => setDialogOpen(!dialogOpen);

  const handleLogout = () => {
    console.log('clicked logout from header', isFixed);
    handleSignout();
    // router.push('/');
  };

  useEffect(() => {
    console.log('is Auth at refresh', isAuth);
  }, [isAuth]);

  const handleRedirect = () => {
    navigate(`/selfregister`);
  };

  return (
    <HeaderWrapper className={clsx(className)}>
      <Container
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          height: '100%'
        }}
      >
        <Box
          alignItems="center"
          mr={2}
          minWidth="170px"
          sx={{ display: { xs: 'flex', md: 'flex' } }}
        >
          <Link component={RouterLink} variant="subtitle2" to="#">
            <a>
              <Image height={100} mb={0.5} mt={6} src="/assets/images/logo.svg" alt="logo" />
            </a>
          </Link>
        </Box>

        <Box alignItems="center" sx={{ display: { xs: 'flex', md: 'flex' } }}>
          {isAuth === true && (
            <>
              <Typography fontWeight="600" mb={2} sx={{ display: { xs: 'none', md: 'flex' } }}>
                Hello {email} |
              </Typography>
              <Box color="#FF1493" onClick={handleLogout} style={{ cursor: 'pointer' }}>
                <Typography fontWeight="600" mb={2}>
                  Log Out
                </Typography>
                {/* <Button variant="text">Logout</Button> */}
              </Box>
            </>
          )}
          {!isAuth && (
            <>
              <Button
                type="button"
                variant="contained"
                sx={{
                  height: '30px',
                  width: '160px',
                  ml: '4px',
                  color: 'white',
                  backgroundColor: '#000000'
                }}
                onClick={handleRedirect}
              >
                Join Zimta
              </Button>
              <Box component={IconButton} ml={2} p={1.25} bgcolor="grey.200" onClick={toggleDialog}>
                <PersonOutline />
              </Box>
            </>
          )}
        </Box>

        <Dialog open={dialogOpen} fullWidth={isMobile} scroll="body" onClose={toggleDialog}>
          <Login onclose={toggleDialog} />
        </Dialog>
      </Container>
    </HeaderWrapper>
  );
}
